import Network from '../../network.js'

export default () => ({
  getSavedPosts({ chatId, search, threadId, page, perPage, sort }) {
    return Network.getWithConfig(
      `/forum-chats/${chatId}/saved-posts`,
      {
        params: { search, threadId, page, perPage, sort }
      },
      true
    )
  },
  toggleThreadSave({ chatId, threadId }) {
    return Network.put(`/forum-chats/${chatId}/threads/${threadId}/save`, null, true)
  },
  toggleResponseSave({ chatId, threadId, responseId }) {
    return Network.put(`/forum-chats/${chatId}/threads/${threadId}/responses/${responseId}/save`, null, true)
  }
})
